import { useState } from "react";
import Layout from "../layouts/layout";
import { toast } from "react-toastify";
import { BASE_URL } from "../config";
import styles from "../styles/_screens/openfrmtExport.module.scss";

const CURRENT_YEAR = new Date().getFullYear();
const YEARS = [];
for (let y = CURRENT_YEAR; y >= 2023; y--) {
  YEARS.push(y);
}

const OpenfrmtExport = () => {
  const [year, setYear] = useState(CURRENT_YEAR);
  const [loading, setLoading] = useState(false);

  const rawToken = localStorage.getItem("token");
  const token = rawToken ? JSON.parse(rawToken) : null;

  const handleExport = async () => {
    if (!token) {
      toast.error("יש להתחבר מחדש למערכת");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/appointment/openfrmt-export`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ year, vatNumber: "305510273" }),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => null);
        throw new Error(errData?.message || "Failed to generate export");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `OPENFRMT_${year}.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast.success("הקובץ הופק בהצלחה");
    } catch (err) {
      console.error("OPENFRMT export error:", err);
      toast.error(err.message || "שגיאה בהפקת הקובץ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.card}>
          <h1 className={styles.title}>ייצוא פלט ממוחשב לרשות המיסים</h1>
          <p className={styles.subtitle}>
            הפקת קובץ OPENFRMT לביקורת מס
          </p>

          <div className={styles.infoBox}>
            <div className={styles.infoIcon}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="#3b82f6" strokeWidth="2" />
                <path d="M10 9v5" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" />
                <circle cx="10" cy="6.5" r="1" fill="#3b82f6" />
              </svg>
            </div>
            <div className={styles.infoText}>
              <p>
                קובץ OPENFRMT הוא פלט ממוחשב בפורמט הסטנדרטי של רשות המיסים בישראל.
                הקובץ מכיל את כל הנתונים הכספיים של העסק לשנה שנבחרה,
                כולל פירוט תשלומים, חשבוניות ומסמכי הכנסה.
              </p>
              <p>
                הקובץ שיופק הוא קובץ ZIP המכיל שני קבצים: INI.txt ו-BKMVDATA.txt
                בהתאם לתקן OPENFRMT גרסה 1.31.
              </p>
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>בחר שנת דיווח</label>
            <select
              className={styles.select}
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
            >
              {YEARS.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>

          <button
            className={styles.exportBtn}
            onClick={handleExport}
            disabled={loading}
          >
            {loading ? (
              <span className={styles.spinner} />
            ) : (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: 8 }}>
                <path
                  d="M10 3v10m0 0l-3.5-3.5M10 13l3.5-3.5M3 17h14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            {loading ? "מפיק קובץ..." : "הפק ויצא קובץ"}
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default OpenfrmtExport;
